import { FlexCol } from "@design-system/Layout/Flex";
import { Text } from "@design-system/Typography/Text";
import { type FC } from "react";
import { useRecentFrameworkProjects } from "../../data";
import { RecentFrameworkProjectTable } from "./Table";
import { useRecentFrameworkProjectsTranslations } from "./i18n";
export const RecentProjects: FC = () => {
    const { recentFrameworkProjects, isPending } = useRecentFrameworkProjects();
    const { t, keys } = useRecentFrameworkProjectsTranslations();

    if (isPending) {
        return null;
    }
    return (
        <FlexCol gap="4">
            <Text variant="header3">{t(keys.title)}</Text>
            <RecentFrameworkProjectTable
                recentFrameworkProjects={recentFrameworkProjects ?? []}
            />
        </FlexCol>
    );
};
